import { CreditCardModule } from './creditCard'

const PaymentModule = {
  namespaced: true,
  modules: {
    creditCard: CreditCardModule
  }
}

export {
  PaymentModule
}
